import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { useUpdateMicrosoftAdsStatusMutation } from '../../../slices/adSlice';
import { MicrosoftAdsStatusEnum } from '../../../types/enums';

interface AdGroupStatusSelectProps {
  adgroupId: string;
  microsoftAdsStatus: string;
}

const MicrosoftAdsSelect: React.FC<AdGroupStatusSelectProps> = ({
  adgroupId,
  microsoftAdsStatus,
}) => {
  const [updateStatus] = useUpdateMicrosoftAdsStatusMutation();

  const getMicrosoftAdsEnabled = () => {
    return microsoftAdsStatus;
  };

  const handleChange = (event: SelectChangeEvent) => {
    updateStatus({
      adgroup_id: adgroupId,
      status: event.target.value,
    });
  };

  return (
    <Box sx={{ minWidth: 120, marginRight: '1rem' }}>
      <FormControl fullWidth>
        <InputLabel id="status-select-label">Microsoft Ads</InputLabel>
        <Select
          labelId="status-select-label"
          id="status-select"
          value={getMicrosoftAdsEnabled()}
          label="Status"
          onChange={handleChange}
        >
          <MenuItem value={MicrosoftAdsStatusEnum.Default}>Default</MenuItem>
          <MenuItem value={MicrosoftAdsStatusEnum.Approved}>Approved</MenuItem>
          <MenuItem value={MicrosoftAdsStatusEnum.Paused}>Paused</MenuItem>
          <MenuItem value={MicrosoftAdsStatusEnum.Disabled}>Disabled</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

export default MicrosoftAdsSelect;
